import { Diagnosis } from './Diagnosis';
import { Color } from 'src/games/shared/ColorValue';
import { Helpers } from './Helpers';

/**
 * Represents the game state, passed around from scene to scene
 * */
export class GameState {
    public numberOfDiagnosisOptions: number;
    public diagnosisOptions: Diagnosis[];
    public correctDiagnosis: Diagnosis;
    public sceneNumber: number;
    public hasSeenQuiz: boolean = false;

    /**
     * Keeps track of the current game state at all times
     * Dynamically changes!
     */
    public static current: GameState;

    constructor() {
        this.numberOfDiagnosisOptions = 3;
        this.getDiagnosisOptions();
        this.sceneNumber = 0;
    }

    /**
     * Generate all diagnosis options (one will be picked for the game, the others will be used at the end for options in the quiz)
     */
    public generateRandomDiagnosisOptions(): void {
        this.diagnosisOptions = [];
        while (this.diagnosisOptions.length < this.numberOfDiagnosisOptions + 1) {
            let diseaseName = Diagnosis.getRandomDiseaseName();
            let diagnosisOption = new Diagnosis(diseaseName);

            if (this.diagnosisOptions.length === 0) {
                this.diagnosisOptions.push(diagnosisOption);
            }
            else {
                // Ensure uniqueness of all diagnoses
                if (this.isUnique(diagnosisOption)) {
                    this.diagnosisOptions.push(diagnosisOption);
                }
            }
        }
        // Assign the last one as the correct diagnosis for this game
        this.correctDiagnosis = this.diagnosisOptions.pop();

        // Create an option that is almost the same as correct option to make the quiz harder
        var similarOption = this.diagnosisOptions[Phaser.Math.Between(0, this.diagnosisOptions.length - 1)];
        similarOption.bacteriaCount = this.correctDiagnosis.bacteriaCount + 1;
        similarOption.bacteriaColor = this.correctDiagnosis.bacteriaColor;
        similarOption.reactionAsset = this.correctDiagnosis.reactionAsset;
        similarOption.healthyCellColor = this.correctDiagnosis.healthyCellColor;
        similarOption.sickCellColor = this.correctDiagnosis.sickCellColor;
        // Force them to have different color changer colors
        similarOption.colorChangerColor = this.getUnusedColor(similarOption, this.correctDiagnosis.colorChangerColor);
    }

    getDiagnosisOptions(): void {
        var options = Helpers.scrambleArray([...Diagnosis.DIAGNOSIS_OPTIONS]);
        this.diagnosisOptions = options.slice(0, this.numberOfDiagnosisOptions + 1);
        this.correctDiagnosis = this.diagnosisOptions.pop();
        this.diagnosisOptions[0].bacteriaColor = this.correctDiagnosis.bacteriaColor; 
        this.diagnosisOptions[0].bacteriaCount = this.correctDiagnosis.bacteriaCount + 1;
    }

    public getUnusedColor(diagnosis: Diagnosis, notThisColor: number): number {
        let actualColors = [
            Color.COLORS.get("red"),
            Color.COLORS.get("blue"),
            Color.COLORS.get("green"),
            Color.COLORS.get("yellow"),
            Color.COLORS.get("orange"),
            Color.COLORS.get("purple"),
            Color.COLORS.get("teal"),
            Color.COLORS.get("pink"),
        ];

        // Grab a color that hasn't been used in the current diagnosis AND isn't the same as the correct diagnosis's color
        for (var c of actualColors) {
            if (diagnosis.colorChangerColor !== c && diagnosis.bacteriaColor !== c && diagnosis.healthyCellColor !== c && diagnosis.sickCellColor !== c &&
                notThisColor !== c) {
                return c;
            }
        }
    }

    /**
     * Checks that the diagnosis is unique
     */
    public isUnique(diagnosisOption: Diagnosis): boolean {
        for (var option of this.diagnosisOptions) {
            if (Diagnosis.hasSameDiseaseName(diagnosisOption.diseaseName, option.diseaseName)) {
                // Disease names must be unique regardless of color
                return false;
            }
        }
        return true;
    }

    hasSameColors(colors1: Color[], colors2: Color[]): boolean {
        if (colors1.length !== colors2.length) {
            return false;
        }

        for (var i = colors1.length; i--;) {
            if (colors1[i].value !== colors2[i].value) {
                return false;
            }
        }

        return true;
    }

}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/objects/GameState.ts